import { render, staticRenderFns } from "./PelleEffectsModal.vue?vue&type=template&id=f65fbcc2&scoped=true&"
import script from "./PelleEffectsModal.vue?vue&type=script&lang=js&"
export * from "./PelleEffectsModal.vue?vue&type=script&lang=js&"
import style0 from "./PelleEffectsModal.vue?vue&type=style&index=0&id=f65fbcc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65fbcc2",
  null
  
)

export default component.exports